
import LoadMore from 'vux/src/components/load-more/index.vue'

import {mapMutations} from 'vuex'


export default {
props:{
text:[String]
},
computed:{
ctext:function(){
if(this.text)
{
return this.text;
}else{
return this.defaulttext;
}
}
},
components: {
LoadMore
},
data(){
return {
defaulttext:'暂无数据'
}
},

methods: {
...mapMutations({
header: 'updateHeaderStatus',
})

}
}



// WEBPACK FOOTER //
// ./src/components/Null.vue